import {
    FETCH_REFERRED_DRIVERS_REQUEST,
    FETCH_REFERRED_DRIVERS_SUCCESS,
    FETCH_REFERRED_DRIVERS_FAILURE,
} from "../actions/types";

const initialState = {
    referredDrivers: [],
    total: 0,
    page: 1,
    size: 10,
    pages: 0,
    loading: false,
    error: null,
};

export default function referredDriverReducer(
    state = initialState,
    action
) {
    switch (action.type) {
        case FETCH_REFERRED_DRIVERS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case FETCH_REFERRED_DRIVERS_SUCCESS:
            return {
                ...state,
                loading: false,
                referredDrivers:
                    action.payload.data,
                total:
                    action.payload.total,
                page:
                    action.payload.page,
                size:
                    action.payload.size,
                pages:
                    action.payload.pages,
            };

        case FETCH_REFERRED_DRIVERS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
}